<template>

  <div>
    <div class="sayfahead">
      <h1>Bildirim Merkezi</h1>
      <el-button-group class="float-right">
        <router-link tag="button" class="el-button YeniBtn el-button--small"
                     to="/iletisim/sms"> Mesaj Gönder
        </router-link>
        <router-link tag="button" class="el-button YeniBtn el-button--small"
                     to="/iletisim/sms/gecmis"> Mesaj Geçmişi
        </router-link>
      </el-button-group>
    </div>
    <div class="icerik">
      <el-row :gutter="24">
        <Yukleniyor :data="lo"></Yukleniyor>
        <el-form @submit.prevent.native="Submit" :model="Form" :rules="FormHata" ref="Form">
          <el-col :span="12">
            <el-form-item label="Bildirim İçerik" class="Tooltip" prop="Sablon">
              <el-input :disabled="!Form.Durum" ref="mesaj" type="textarea" rows="6" resize="none" v-model="Form.Sablon"
                        placeholder="Sınırsız mesaj yazabilirsiniz. Normalde 160 karaktere bölünerek ücretlendirilecektir. En az 5 karakter yazabilirsiniz."></el-input>
            </el-form-item>
            <el-col :span="24">
              <el-divider content-position="left">Değişkenler</el-divider>
              <el-button-group>
                <el-button :disabled="!Form.Sablon" v-for="d in Degisken" @click="setDegisken(d.Value)" size="mini"
                           :type="d.type">{{d.Text}}
                </el-button>
              </el-button-group>
            </el-col>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="24">
              <el-col :span="3">
                <el-form-item label="Durum" class="Tooltip" prop="Durum">
                  <el-tooltip class="item" effect="dark"
                              content="Bildirim Merkezi aktif olarak çalışır" placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-switch v-model="Form.Durum"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="Mevcut Ay" class="Tooltip" prop="Ay">
                  <el-tooltip class="item" effect="dark"
                              content="Mevcut aydaki borçlarıda dahil eder." placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-switch :disabled="!Form.Durum" v-model="Form.Ay"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Bildirim Günü" class="Tooltip" prop="Gun">
                  <el-tooltip class="item" effect="dark"
                              content="Bildirimlerin gönderileceği ayın günü"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-input-number :disabled="!Form.Durum" v-model="Form.Gun" :precision="0" :step="1" :min="1"
                                   :max="28"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Bildirim Saati" class="Tooltip" prop="Saat">
                  <el-select :disabled="!Form.Durum" v-model="Form.Saat" placeholder="Saat Seçiniz">
                    <el-option
                      v-for="item in Saatler"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Minimum Borç" class="Tooltip" prop="Tutar">
                  <el-tooltip class="item" effect="dark"
                              content="Yazılan tutardan fazla borcu olanlara gönderilir"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-input :disabled="!Form.Durum" v-model="Form.Tutar"
                            :max="28"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <hr>
                <button type="button" @click="Submit"
                        class="el-button mt-2 el-button--success el-button--mini btn-block">Kaydet
                </button>
              </el-col>
            </el-row>

          </el-col>
        </el-form>

      </el-row>
    </div>
  </div>

</template>

<script>
  import Yukleniyor from "../../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: false,
        Saatler: [
          {label: '10:00 - 11:00', value: '10'},
          {label: '12:00 - 13:00', value: '12'},
          {label: '14:00 - 15:00', value: '14'},
          {label: '16:00 - 17:00', value: '16'},
          {label: '18:00 - 19:00', value: '18'},
        ],
        Form: {
          Durum: null,
          Ay: null,
          Gun: null,
          Saat: null,
          Sablon: null,
          Tutar: 0,
        },
        FormHata: {
          Gun: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Saat: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Sablon: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        Degisken: [
          {Text: "Ad Soyad", Value: '[AdSoyad] ', type: 'default'},
          {Text: "Bina Adı", Value: '[Bina] ', type: 'default'},
          {Text: "Kat", Value: '[Kat] ', type: 'default'},
          {Text: "Mesken No", Value: '[kNo] ', type: 'default'},
          {Text: "Online İşlemler Şifresi", Value: '[Parola] ', type: 'default'},
          {Text: "Güncel Borç", Value: '[Borc] ', type: 'default'},
          {
            Text: "Hazır Şablon",
            Value: 'MERHABA [AdSoyad], [Bina] APARTMANI [Kat] KATINDA BULUNAN [kNo] NOLU MESKENİNİZİN ÖDENMEMİŞ [Borc]TL BORCU BULUNMAKTADIR. ÖDEMELERİNİZİ ONLİNE İŞLEM MERKEZİMİZDEN [Parola] PAROLA İLE GİRİŞ YAPARAK YAPABİLİRSİNİZ.',
            type: 'default'
          },
        ],

      }
    },
    methods: {
      setDegisken(val) {
        this.Form.Sablon = this.Form.Sablon + ' ' + val;
        this.$refs.mesaj.focus();
      },
      SayfaYukle() {
        this.$store.dispatch("Get", {path: 'iletisim/bildirim'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Form = response.Data;
            }
          });
      },

      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$store.dispatch("Post", {...this.Form, path: 'iletisim/bildirim/'})
              .then(response => {
                this.lo = false;
                if (response.Status == "OK") {
                  this.$message.success(response.Mesaj);
                } else {
                  this.$message.error(response.Mesaj);
                }
              })
          }
        })

      },
    },
    created() {

      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Iletisim/sms/bildirimmerkezi.vue